import script from "./ApplicationStatusContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationStatusContainer.vue?vue&type=script&setup=true&lang=ts"

import "./ApplicationStatusContainer.vue?vue&type=style&index=0&id=316ac376&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-316ac376"]])

export default __exports__